(function ($) {
    function submitForm(form, clickedBtn) {
        
        // create loading
        clickedBtn.attr('disabled', true).addClass('loading');
        
        if(typeof recaptcha_site_key_v3 !== 'undefined' && recaptcha_site_key_v3 !== undefined) {
            grecaptcha.ready(function() {
                grecaptcha.execute(recaptcha_site_key_v3,{
                    action: recaptcha_action
                }).then(function(token) {
                    if (token) {

                        form.find('[name="recaptcha"]').val(token);
                        form.find('#recaptcha-error').addClass('d-none');
                        var params = form.serialize();
                        
                        $.ajax({													
                            method: 'POST',
                            url: cyclone3.domain + '/json/' + cyclone3.lng + '/' + form.data('service'),
                            data: params									
                        }).done(function(e) {
                            // remove loading
                            clickedBtn.attr('disabled', false).removeClass('loading');	
                            form.find('.form-group').removeClass('error');					
                            form.find('.captcha').removeClass('is-error');
                            form.find('.alert-danger').addClass('d-none');		

                            // if error == ICO - superadmin
                            if ((e.success == false) && (e.invalid.indexOf('ICO') > -1) && ($('#formUserLogin').length)) {

                                $.each(e.invalid, function( index, errorName ) {
                                    if (errorName == "recaptcha") {                
                                        form.find('#recaptcha-error').removeClass('d-none');
                                    } else if (errorName == "ICO") {
                                        // show ICO input
                                        $('h2.title-ICO').removeClass('d-none');
                                        form.find('.ICO').removeClass('d-none').addClass('required-field');
                                        form.find('#ICO').prop('required',true);
                                        // hide email, password, footer links
                                        $('h2.title-login, .form-footer__links').addClass('d-none');
                                        form.find('.login, .password').addClass('d-none');
                                        
                                        // if ICO displayed with error
                                        if (form.find('#ICO').data('js-ico') == true) {
                                            $('.form-group.ICO').addClass('error');
                                            $.each(e.invalid_custom, function( index, errorName ) {
                                                form.find('.error-'+errorName).removeClass('d-none').show();
                                                return false;
                                            });
                                        // if ICO displayed first time
                                        } else {
                                            form.find('#ICO').attr('data-js-ico',true);
                                        }
                                    } else {
                                        form.find('[name="' + errorName + '"]').closest('.form-group').addClass('error'); 
                                    }
                                });
                            // if error
                            } else if (e.success == false) {
                                $.each(e.invalid, function( index, errorName ) {
                                    if (errorName == "recaptcha") {                
                                        form.find('#recaptcha-error').removeClass('d-none');
                                    } else {
                                        form.find('[name="' + errorName + '"]').closest('.form-group').addClass('error'); 
                                    }
                                });
                                
                                $.each(e.invalid_custom, function( index, errorName ) {
                                    form.find('.error-'+errorName).removeClass('d-none').show();
                                    return false;
                                });
                            // if success   
                            } else if (e.success == true) {    
                                window.dataLayer = window.dataLayer || [];
                                window.dataLayer.push({
                                    'event': 'formSubmission',
                                    'formID': form.attr('id')
                                });
                                if (e.redirect_url){
                                    window.location.replace(e.redirect_url);
                                } else {                                                    
                                    form.find('.form-body').hide();                  
                                    form.find('.form-success').removeClass('d-none').show();
                                }
                            } 
                        });
                    } else {
                        form.find('#recaptcha-error').removeClass('d-none');
                        form.find('.captcha').addClass('is-error');
                        return false;
                    }
                });
            });                
        }
    }
    
    
    // CONTACT FORM    
    $('#formContact button').on('click', function (e) {        
        e.preventDefault();
        submitForm($('#formContact'),$(this));        
    });
    
    // USER REGISTRATION FORM
    if ($('#formRegister').length) {
        
            var form = $('#formRegister');
            $('select#vat_payer').on('change', function() {
                
                var selected = $(this).val();
                if (selected == 'Som platca DPH') {
                    $('#icdph').closest('.form-group').removeClass('d-none');
                } else {
                    $('#icdph').closest('.form-group').addClass('d-none');
                }
                
            });
        
        $('#formRegister button').on('click', function (e) {            
            e.preventDefault();            
            submitForm($('#formRegister'),$(this));
        });        
    }
    
    // LOGIN FORM
    $(document).on("click", '#formUserLogin button', function(e) {        
        e.preventDefault();
        submitForm($('#formUserLogin'),$(this));
    });    
    
    // FORGOT / LOST PASSWORD FORM
    $(document).on("click", '#formLostPassword button', function(e) {        
        e.preventDefault();
        submitForm($('#formLostPassword'),$(this));
    });
    
    // EDIT PROFILE
    $(document).on("click", '#formEditProfile button', function(e) {        
        e.preventDefault();
        submitForm($('#formEditProfile'),$(this));
    });
    
    // EDIT PASS
    $(document).on("click", '#formEditPass button', function(e) {        
        e.preventDefault();
        submitForm($('#formEditPass'),$(this));
    });
    
    // DELETE USER
    $(document).on("click", '#formDeleteUser button', function(e) {        
        e.preventDefault();
        submitForm($('#formDeleteUser'),$(this));
    });
    
    // ADD USER
    $(document).on("click", '#formAddUser button', function(e) {        
        e.preventDefault();
        submitForm($('#formAddUser'),$(this));
    });
    
    // ORDER DELIVERY - NEW ADDRESS
    $(document).on("click", '#formAddAddress button[type="submit"]', function(e) {        
        e.preventDefault();
        $('#formAddAddress').find('[name="delivery_person"]').val($('#orderDelivery [name="delivery_person"]:checked').val());
        $('#formAddAddress').find('#new_address').val("yes");
        $('#formAddAddress').submit();
    });
    
    // ORDER DELIVERY - NEW ADDRESS
    $(document).on("click", '#formAddAddress button[type="button"]', function(e) {        
        e.preventDefault();
    });
    
    // ORDER DELIVERY - NEW PERSON
    $(document).on("click", '#formAddPerson button[type="submit"]', function(e) {        
        e.preventDefault();
        $('#formAddPerson').find('#new_person').val("yes");
        $('#formAddPerson').find('[name="delivery_address"]').val($('#orderDelivery [name="delivery_address"]:checked').val());
        $('#formAddPerson').submit();
    });
    
    // ORDER DELIVERY - NEW Person
    $(document).on("click", '#formAddPerson button[type="button"]', function(e) {        
        e.preventDefault();
    });    
    
    // PRICE OFFER FORM    
    $('#formPriceOffer button').on('click', function (e) {        
        e.preventDefault();
        submitForm($('#formPriceOffer'),$(this));        
    });    
    
    // ASK FOR CATALOG FORM    
    $('#formAskForCatalog button').on('click', function (e) {        
        e.preventDefault();
        submitForm($('#formAskForCatalog'),$(this));        
    }); 
    
    // RESERVE DATE FOR SHOWROOM FORM
    $(document).on("click", '#formReserveShowroom button', function(e) {        
        e.preventDefault();
        submitForm($('#formReserveShowroom'),$(this));
    });
    
    // download invoice
    $(document).on("click", '.btnDownloadInvoice', function(e) {        
        e.preventDefault();
        var clickedBtn = $(this);
        // create loading
        clickedBtn.attr('disabled', true).addClass('loading');
        $('.error-invoice_not_available').addClass('d-none');
        $.ajax({													
            method: 'POST',
            url: cyclone3.domain + '/json/' + cyclone3.lng + '/invoice_download',
            data: {
                ei: clickedBtn.data('refid'),
                oi: clickedBtn.data('orgid')
            }					
        }).done(function(e) {
            // remove loading
            clickedBtn.attr('disabled', false).removeClass('loading');	
            
            if (e.success == false) {
                  $('.error-invoice_not_available').removeClass('d-none').show();                
            } else if (e.success == true) {    
                if (e.file_url){
                    window.open(e.file_url , '_blank');
                }
            } 
        });
    });
    
    // dev sync
    $(document).on("click", '.btnSyncOrders', function(e) {        
        e.preventDefault();
        var clickedBtn = $(this);
        
        // create loading
        clickedBtn.attr('disabled', true).addClass('loading');
        $('.alert_sync_order').remove();
       
        $.ajax({													
            method: 'POST',
            url: cyclone3.domain + '/service/sync_orders' ,
            data:{
                id_entity: clickedBtn.data("id-entity")
            }		
        }).done(function(data) {
            // remove loading 
            clickedBtn.attr('disabled', false).removeClass('loading');            
            $('.table').parent().prepend($(data).filter('.result').html());
        });
    });
    
    $(document).on("click", '.btnSyncFirm', function(e) {        
        e.preventDefault();
        var clickedBtn = $(this);
        
        // create loading
        clickedBtn.attr('disabled', true).addClass('loading');
        $('.alert_sync_order').remove();
       
        $.ajax({													
            method: 'POST',
            url: cyclone3.domain + '/service/sync_orders' ,
            data:{
                firm: 1
            }		
        }).done(function(data) {
            // remove loading 
            clickedBtn.attr('disabled', false).removeClass('loading');            
            $('.table').parent().prepend($(data).filter('.result').html());
        });
    });
    
    $(document).on("click", '.btnSyncProducts', function(e) {        
        e.preventDefault();
        var clickedBtn = $(this);
        
        // create loading
        clickedBtn.attr('disabled', true).addClass('loading');
        $('.alert_sync_order').remove();
       
        $.ajax({													
            method: 'POST',
            url: cyclone3.domain + '/service/sync_orders' ,
            data:{
                products: 1
            }		
        }).done(function(data) {
            // remove loading 
            clickedBtn.attr('disabled', false).removeClass('loading');            
            $('.table').parent().prepend($(data).filter('.result').html());
        });
    });
    
    $(document).on("click", '.btnSyncContacts', function(e) {        
        e.preventDefault();
        var clickedBtn = $(this);
        
        // create loading
        clickedBtn.attr('disabled', true).addClass('loading');
        $('.alert_sync_order').remove();
       
        $.ajax({													
            method: 'POST',
            url: cyclone3.domain + '/service/sync_orders' ,
            data:{
                contacts: 1
            }		
        }).done(function(data) {
            // remove loading 
            clickedBtn.attr('disabled', false).removeClass('loading');            
            $('.table').parent().prepend($(data).filter('.result').html());
        });
    });
})(jQuery);